import React from 'react'
import Title from './title'
import Information from './information'
import HowWeCollect from './howWeCollect'
import PurposeOfInformation from './purposeOfInformation'
import DataSharing from './dataSharing'
import DataRetention from './dataRetention'
import AppPermission from './appPermission'
import UserRoles from './userRoles'
import DataSecurity from './dataSecurity'
import ChildrenPrivacy from './childrenPrivacy'
import YourRights from './yourRights'
import ChangesToPolicy from './changesToPolicy'
import Footer from '../ui/layout/Footer'
import Navbar from '../ui/layout/Navbar'

const Page = () => {
  return (
    <> 
        <div style={{minHeight: "150px"}}>
<Navbar/>
        </div>
        <div style={{marginLeft: "100px", marginRight: "100px"}}>
             <Title/>
             <Information/>
             <HowWeCollect/>
             <PurposeOfInformation/>
             <DataSharing/>
             <DataRetention/>
             <AppPermission/>
             <UserRoles/>
             <DataSecurity/>
             <ChildrenPrivacy/>
             <YourRights/>
             <ChangesToPolicy/>
        </div>
         <Footer/>
    </>
  )
}

export default Page